import { T } from "./tokens";

interface LogoV2Props {
  size?: number;
  color?: string;
  showImage?: boolean;
}

export function LogoV2({ size = 28, color = T.gold, showImage = true }: LogoV2Props) {
  const heFontSize = size * 0.95;
  const enFontSize = size * 0.95;
  const markH = size * 2.3;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: size * 0.45, direction: "rtl" }}>
      {showImage && (
        <img
          src="/v2/musicians-gold.png"
          alt=""
          style={{
            height: markH,
            width: "auto",
            display: "block",
            filter: color === T.gold ? "none" : "brightness(0) saturate(100%)",
          }}
        />
      )}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: size * 0.08 }}>
        <div
          style={{
            fontFamily: T.serif,
            fontSize: heFontSize,
            fontWeight: 700,
            color,
            letterSpacing: "0.005em",
            lineHeight: 1,
          }}
        >
          ניגונים
        </div>
        <div
          style={{
            fontFamily: T.serif,
            fontSize: enFontSize,
            fontWeight: 600,
            color,
            letterSpacing: "0.04em",
            lineHeight: 1,
            fontStyle: "italic",
            opacity: 0.92,
            direction: "ltr",
          }}
        >
          Niggunim
        </div>
      </div>
    </div>
  );
}
